module.exports = __webpack_public_path__ + "static/media/09_MEDS-1.9-ES-14 1.08f444de.svg";